<template>
    <div>
        <facebook-login/>
    </div>
</template>

<script>

    import FacebookLogin from "@/modules/Integration/Facebook/components/FacebookLogin";

    export default {
        name: "FacebookConnect",
        components: { FacebookLogin },
    }
</script>

<style/>
